// Utility to detect a "compact" embedding (e.g. webview or iframe) where certain UI panels
// like Achievements and Theme selector should be hidden to save space.
// Detection strategy:
// 1. Explicit query param ?compact=1 overrides everything.
// 2. window.name or parent indicator containing 'webview'.
// 3. User agent hints for common in-app webviews (very lightweight heuristic).
// 4. If inside an iframe we treat as compact.

export function isCompactMode(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('compact') === '1') return true;
  } catch {}

  try {
    if (typeof window !== 'undefined') {
      if ((window.name || '').toLowerCase().includes('webview')) return true;
      const ua = navigator.userAgent.toLowerCase();
      if (ua.includes('wv)') || ua.includes('webview') || ua.includes('line/') || ua.includes('fbav')) return true;
      if (window.self !== window.top) return true; // embedded (iframe)
    }
  } catch {}
  return false;
}

let cached: boolean | null = null;
export function getCompactMode(): boolean {
  if (cached == null) cached = isCompactMode();
  return cached;
}
